import request from "@/utils/request";
import qs from "qs";
import { getLogionUserInfo } from "@/utils/auth"; // 验权

/**
 * 查询会员统计
 * @returns {AxiosPromise}
 */
export function getUsersStatis(data) {
  return request({
    url: "/bulletin/getUsersRelationDtoList",
    method: "get",
    params: data
  });
}

/**
 * 查询订单统计
 * @returns {AxiosPromise}
 */
export function getOrderStatis(data) {
  return request({
    // url: "/report/getOrderStatis",
    url: "/bulletin/getOrderStatisticsList",
    method: "get",
    params: data
  });
}

/**
 * 查询余额统计
 * @returns {AxiosPromise}
 */
export function getBalanceStatis(data) {
  return request({
    url: "/bulletin/getBulletinBoardVo",
    method: "get",
    params: data
  });
}

/**
 * 查询下级代理信息列表
 */
export function getSubordinateList(data) {
  const url = getLogionUserInfo()?.teamLogo ? `/bulletin/getLowerLevelAgentDtoList` : `/bulletin/getLowerLevelAgentDtoListForTeam0`
  return request({
    url,
    method: "get",
    params: data
  });
}
// 查询奖励池统计
export function getTbcRewardPool(data) {
  return request({
    url: "/bulletin/getTbcRewardPool",
    method: "get",
    params: data
  });
}
// 查询btc账户
export function getTbcWithdraw(data) {
  return request({
    url: "/bulletin/getTbcWithdraw",
    method: "get",
    params: data
  });
}
// 提现
export function withdraw(params) {
  return request.post("/tbcWithdraw/withdrawTbc", qs.stringify(params));
}
// 查询大区累计业绩
export function getDepartmentalPerformance(data) {
  return request({
    url: "/bulletin/getDepartmentalPerformance",
    method: "get",
    params: data
  });
}

// 查询代理业绩数据
export function getAgentPerformance(data) {
  return request({
    url: "/bulletin/getAgentRegionsAchievement",
    method: "get",
    params: data
  });
}



export function getAgentDetailList(params) {
  return request({
    url: "/bulletin/getLowerLevelAgentDtoListForTeam0",
    method: "get",
    params
  });
}